import { LicenseManager } from "ag-grid-enterprise";
import { useEffect } from "react";
import { getAGGridLicense } from "../utils/api/BusinessUnitApi";

export function SetAGGridsLicense() {
  useEffect(() => {
    getAGGridLicense().then((license) => {
      LicenseManager.setLicenseKey(license ?? "");
    });
  }, []);
}
